import { PageId } from 'constants/pages'
import { TPageConfig } from 'models/common.model'
import { THEMES } from 'root-constants'
import { PageIdWoofzRfnd3 } from './pages'

export const ID_TO_PAGE_CONFIG_MAP_WOOFZ_RFND3: Record<
  Exclude<PageIdWoofzRfnd3, PageIdWoofzRfnd3.ACCOUNT_NOVE8>,
  TPageConfig
> = {
  [PageId.SEX_RFND3]: {
    id: PageId.SEX_RFND3,
    hasHeader: true,
    progressBarHidden: true,
    progressBar: 'controlled',
  },
  [PageId.DOG_AGE_RFND3]: {
    id: PageId.DOG_AGE_RFND3,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageId.DOG_BREED_RFND3]: {
    id: PageId.DOG_BREED_RFND3,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageId.URGE_RFND3]: {
    id: PageId.URGE_RFND3,
    hasHeader: true,
    theme: THEMES.URGE,
  },
  [PageId.COMMANDS_61_RFND3]: {
    id: PageId.COMMANDS_61_RFND3,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageId.COMMANDS_62_RFND3]: {
    id: PageId.COMMANDS_62_RFND3,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageId.COMMANDS_63_RFND3]: {
    id: PageId.COMMANDS_63_RFND3,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageId.URGE_RFND3_2]: {
    id: PageId.URGE_RFND3_2,
    hasHeader: true,
    theme: THEMES.URGE,
  },
  [PageId.POTTY_RFND3]: {
    id: PageId.POTTY_RFND3,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageId.BEHAVIOR_RFND3]: {
    id: PageId.BEHAVIOR_RFND3,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageId.TRAINING_RFND3]: {
    id: PageId.TRAINING_RFND3,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageId.PREPARE_FLOW_RFND3]: {
    id: PageId.PREPARE_FLOW_RFND3,
    hasHeader: true,
    hasHeaderBackButton: true,
  },
  [PageId.DOG_STATISTICS_RFND3]: {
    id: PageId.DOG_STATISTICS_RFND3,
    hasHeader: true,
    theme: THEMES.URGE,
  },
  [PageId.EMAIL_RFND3]: {
    id: PageId.EMAIL_RFND3,
    hasHeader: true,
    hasHeaderBackButton: true,
  },
  [PageId.NEWSLETTER_URGE_RFND3]: {
    id: PageId.NEWSLETTER_URGE_RFND3,
    hasHeader: true,
    hasHeaderBackButton: true,
  },
  [PageId.LAST_CHANCE_OFFER_RFND3]: {
    id: PageId.LAST_CHANCE_OFFER_RFND3,
  },
  [PageId.SUBSCRIPTIONS_RFND3]: {
    id: PageId.SUBSCRIPTIONS_RFND3,
  },
  [PageId.CANCEL_OFFER_RFND3]: {
    id: PageId.CANCEL_OFFER_RFND3,
  },
  [PageId.CHAT_UPSELL_RFND3]: {
    id: PageId.CHAT_UPSELL_RFND3,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
  [PageId.UPSELL_RFND3]: {
    id: PageId.UPSELL_RFND3,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
  [PageId.DOWNLOAD_RFND3]: {
    id: PageId.DOWNLOAD_RFND3,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
}
